import React, { Component } from 'react';
import { observer } from 'mobx-react';
import CheckoutLinkForm from './CheckoutLinkForm';
import CheckoutLinkFormService from '../services/CheckoutLinkFormService';

class CheckoutLinkFormContainer extends Component {
  componentDidMount() {
    CheckoutLinkFormService.init();
  }

  render() {
    return (
      <CheckoutLinkForm
        onSubmit={CheckoutLinkFormService.handleSubmit}
        onChange={CheckoutLinkFormService.form.setValue}
        onReset={CheckoutLinkFormService.form.reset}
        values={CheckoutLinkFormService.form.getValues()}
        errors={CheckoutLinkFormService.form.errors}
        submitting={CheckoutLinkFormService.submit.fetching}
        isDirty={CheckoutLinkFormService.form.isDirty}
        onEditProduct={CheckoutLinkFormService.handleEditProduct}
        onDeleteProduct={CheckoutLinkFormService.handleDeleteProduct}
        totalPrice={CheckoutLinkFormService.totalPrice}
        onToggleProduct={CheckoutLinkFormService.handleToggleProduct}
      />
    );
  }
}

export default observer(CheckoutLinkFormContainer);
